import { createFileRoute, RouteContext } from '@tanstack/react-router'

import { TaxWorkerDetails } from '@/containers/taxDetails/TaxWorkerDetails'
export const Route = createFileRoute(
  '/_authenticated/account/_accountDetails/taxDetails/'
)({
  beforeLoad: async () => {
    const routeContext: RouteContext = {
      breadCrumbTitle: 'Taxes',
    }
    return routeContext
  },
  component: TaxWorkerDetails,
})
